import { initWhatsAppDeepLink } from "./whatsapp.js";

function boot() {
  initWhatsAppDeepLink();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}